import React, { useState } from 'react';
import { NetlifyLogsButton } from '~/components/ui/NetlifyLogsButton';
import { Tooltip } from '~/components/ui/Tooltip';
import { copyToClipboard } from '~/lib/utils/netlify-helpers';
import { InspectDeploymentButton } from './InspectDeploymentButton';
import type { SuccessDisplayProps } from '~/lib/types/netlify';

export const SuccessDisplay = ({
  deployedUrl,
  adminUrl,
  deployedId,
  accessToken,
  deployStatus,
}: SuccessDisplayProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const success = await copyToClipboard(deployedUrl);

    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="space-y-3">
      <div className="rounded-lg border border-[#22c55e]/20 bg-[#22c55e]/10 py-4 text-center">
        <div className="i-ph:check-bold w-7 h-7 rounded-full border-2 border-[#22c55e] text-[#22c55e] mx-auto mb-3" />
        <h3 className="text-[#22c55e] text-sm font-medium mb-2">Deployment Successful!</h3>
        <p className="text-[#e7e7e7]/70 text-[10px]">Your site is now live and ready to share</p>
      </div>

      <div className="flex gap-2">
        <a
          href={deployedUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-between gap-2 px-4 py-2 rounded-lg 
            border border-white/10 bg-white/5 hover:bg-white/10 
            transition-all duration-200 group"
        >
          <span
            className="text-sm text-[#e7e7e7] group-hover:text-white 
            transition-colors truncate"
          >
            {deployedUrl.length > 40 ? deployedUrl.slice(0, 40) + '...' : deployedUrl}
          </span>
          <div
            className="i-ph:arrow-square-out w-3.5 h-3.5 text-[#e7e7e7]/70 
              group-hover:text-white transition-colors flex-shrink-0"
          />
        </a>
        <Tooltip content={copied ? 'Copied!' : 'Copy'}>
          <button
            onClick={handleCopy}
            className="p-3.5 rounded-lg border border-white/10 bg-white/5 
              hover:bg-white/10 transition-all duration-200
              text-[#e7e7e7]/70 hover:text-white"
          >
            <div className={copied ? 'i-ph:check w-4 h-4' : 'i-ph:copy w-4 h-4'} />
          </button>
        </Tooltip>
      </div>

      {adminUrl && <InspectDeploymentButton adminUrl={adminUrl} />}

      {deployedId && (
        <div className="mt-2">
          <NetlifyLogsButton
            deployedId={deployedId}
            accessToken={accessToken}
            deployStatus={deployStatus}
            autoExpand={false}
            adminUrl={adminUrl}
          />
        </div>
      )}
    </div>
  );
};
